import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { Router } from '@angular/router';
import { TopicService } from '../topic.service';
import { SubjectModelWithTopics, SubjectModel } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, SpinnerComponent],
  selector: 'app-topic-list',
  templateUrl: './topic-list.component.html',
  styleUrls: ['./topic-list.component.scss']
})
export class TopicListComponent implements OnInit {

  subjects: Observable<SubjectModelWithTopics[]>;
  selectedSubject: number;
  selectedTopic: number;

  constructor(private router: Router,
              private topicService: TopicService) {
  }

  ngOnInit() {
    this.subjects = this.topicService.getTopicsGroupBySubject();
  }

  openSubject(subjectId: number) {
    this.selectedSubject = subjectId;
  }

  openTopic(topicId: number ) {
    this.selectedTopic = topicId;
  }
}
